import React from "react";
import { Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const BOOKING_URL = "https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836";
const appointments = [{
  name: "Initial assessment",
  duration: "30 minutes",
  price: "£50"
}, {
  name: "Follow-up treatment",
  duration: "30 minutes",
  price: "£50"
}, {
  name: "Extended appointment for complex concerns",
  duration: "45 minutes",
  price: "£65"
}];
export default function MusculoskeletalPricing() {
  return <section id="musculoskeletalphysiotherapypricing" data-nav="light" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <div className="mb-10 md:mb-14 text-center sm:text-left">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-primary tracking-tight">
            Musculoskeletal physiotherapy
          </h2>
          <div className="mt-3 h-1 w-16 bg-accent rounded-full mx-auto sm:mx-0" />
        </div>

        <div className="flex flex-col gap-4 md:gap-5">
          {appointments.map((appointment, i) => <div key={appointment.name} data-index={i} className="card bg-secondary/70 border-border p-6 sm:p-7 flex flex-col sm:flex-row sm:items-center justify-between gap-4 transition-all duration-200">
              <div className="flex-1 pr-0 sm:pr-4">
                <h3 className="text-xl md:text-2xl font-display font-semibold text-primary">
                  {appointment.name}
                </h3>
              </div>

              <div className="flex flex-wrap sm:flex-nowrap items-center justify-between sm:justify-end gap-4 sm:gap-6 pt-2 sm:pt-0 border-t border-border/50 sm:border-t-0">
                <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background border border-accent/40 text-foreground text-sm font-medium shadow-2xs">
                  <Clock className="size-4 text-accent" />
                  <span>{appointment.duration}</span>
                </div>

                <div className="text-right min-w-[60px]">
                  <span className="text-2xl md:text-3xl font-display font-bold text-primary">
                    {appointment.price}
                  </span>
                </div>

                <Button asChild size="sm" className="shrink-0">
                  <Link to={BOOKING_URL}>
                    Book Appointment
                  </Link>
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}